import _ from "lodash";
import axios from "axios";
import authClient from "./authClient";

const BASE_URL = process.env.REACT_APP_SETI_URL;

const CancelToken = axios.CancelToken;

class SetiApi {
  fetchStrikeZoneData = params => {
    return authClient
      .post(`${BASE_URL}/v1/models/strikezone`, params)
      .then(response => response.data);
  };

  fetchGroundTruthData = (venue, collectionDate) => {
    const url = _.isEmpty(collectionDate)
      ? `${BASE_URL}/v2/models/groundtruth/venues/${venue}/pitches`
      : `${BASE_URL}/v2/models/groundtruth/venues/${venue}/collectionDates/${collectionDate}/pitches`;

    return authClient.get(url).then(response => response.data);
  };

  fetchGroundTruthCollectionDateData = venueId => {
    return authClient
      .get(
        `${BASE_URL}/v2/models/groundtruth/venues/${venueId}/collectionDates`
      )
      .then(response => response.data);
  };

  fetchQuestionableCallsData = params => {
    return authClient
      .post(`${BASE_URL}/v1/models/shift`, params)
      .then(response => response.data);
  };

  fetchModelBasedAlertingData = params => {
    const { venueId, season, directions } = params;
    const queryParam = directions.reduce(
      (memo, direction) => `${memo}&direction=${direction}`,
      "?"
    );
    return authClient
      .get(
        `${BASE_URL}/v1/stadium/${venueId}/season/${season}/strikeZoneDeviation${queryParam}`
      )
      .then(response => response.data);
  };

  fetchTrackmanAccuracyReport = date => {
    this.trackmanAccuracyReportSource = CancelToken.source();
    return authClient
      .get(`${BASE_URL}/v1/trackmanAccuracy/reports?date=${date}`, {
        cancelToken: this.trackmanAccuracyReportSource.token
      })
      .then(response => response.data);
  };

  cancelTrackmanAccuracyReport = () =>
    this.trackmanAccuracyReportSource.cancel();
}

export default SetiApi;



// WEBPACK FOOTER //
// ./src/httpClients/setiApi.js